import {
  AfterContentChecked,
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  ViewEncapsulation
} from '@angular/core';

import { ExpandableContentDirective } from './expandable-content.directive';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-expandable-panel',
  styleUrls: ['./expandable-panel.component.css'],
  templateUrl: './expandable-panel.component.html'
})
export class ExpandablePanelComponent implements AfterContentChecked, OnInit {
  @Input() cardType: boolean;
  @ContentChildren(ExpandableContentDirective, { descendants: true })
  expandableContents: QueryList<ExpandableContentDirective>;
  @Input() expanded: boolean;
  isExpandable: boolean;
  isHeaderConfigured: boolean;
  @Input() styleClass: string;

  private _header: string;

  get header(): string {
    return this._header;
  }

  @Input()
  set header(value: string) {
    this._header = value;
    this.isHeaderConfigured = value && value.trim() !== '';
  }

  constructor() {}

  ngAfterContentChecked() {
    this.isExpandable = this.expandableContents.length > 0;

    if (this.isExpandable) {
      this.triggerExpandableContent();
    }
  }

  ngOnInit() {
    this.cardType = this.cardType || false;
    this.expanded = this.expanded || false;
  }

  toggleExpand() {
    this.expanded = !this.expanded;
    this.triggerExpandableContent();
  }

  private triggerExpandableContent() {
    this.expandableContents.forEach(expandableContent => {
      if (this.expanded) {
        expandableContent.expand();
      } else {
        expandableContent.collapse();
      }
    });
  }
}
